<template>
  <b-button
    class="kst-button"
    :class="AppCatalog.Router.Back.Class"
    :icon-left="AppCatalog.Router.Back.Icon"
    :label="AppCatalog.Router.Back.Label"
    @click="handleClick"
  />
</template>

<script>
import AppCatalog from "@/services/App/AppCatalog.js";
import RouterMixin from "@/mixins/RouterMixin.js";

export default {
  mixins: [RouterMixin],
  data: () => ({
    AppCatalog: AppCatalog
  }),
  methods: {
    handleClick() {
      this.goBack();
    }
  }
}
</script>